import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = {
  class: "group py-3"
};
const _hoisted_2 = {
  class: "mb-2.5 flex items-start justify-between gap-2"
};
const _hoisted_3 = {
  class: "min-w-0"
};
const _hoisted_4 = ["title"];
const _hoisted_5 = {
  key: 0,
  class: "mt-1 flex items-center gap-1 text-xs text-slate-500"
};
const _hoisted_6 = {
  class: "flex shrink-0 items-center gap-0.5"
};
const _hoisted_7 = {
  key: 0,
  class: "absolute -right-1 -top-1 min-w-[1rem] rounded-full bg-blue-600 px-1 text-center text-[10px] font-semibold leading-4 text-white"
};
const _hoisted_8 = {
  key: 0,
  class: "space-y-2.5 rounded-xl border border-slate-200 bg-gradient-to-br from-slate-50/60 to-white p-3.5"
};
const _hoisted_9 = {
  class: "grid gap-2.5 md:grid-cols-2"
};
const _hoisted_10 = {
  class: "group relative flex flex-col overflow-hidden rounded-lg border border-blue-100 bg-white transition-all duration-200 focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-100 hover:border-blue-200"
};
const _hoisted_11 = {
  class: "flex items-center gap-1.5 border-b border-blue-50 px-3 py-1.5"
};
const _hoisted_12 = ["readonly"];
const _hoisted_13 = {
  key: 0,
  class: "border-t border-red-100 bg-red-50/50 px-3 py-1 text-xs text-red-600"
};
const _hoisted_14 = {
  class: "relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_15 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-1.5"
};
const _hoisted_16 = {
  class: "min-h-[4.25rem] px-3 py-2"
};
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-xs text-slate-400"
};
const _hoisted_18 = {
  key: 1,
  class: "space-y-2.5 rounded-xl border border-slate-200 bg-gradient-to-br from-slate-50/60 to-white p-3.5"
};
const _hoisted_19 = {
  class: "rounded-lg border border-slate-100 bg-white px-3 py-2 text-sm"
};
const _hoisted_20 = {
  class: "flex items-start gap-x-4 gap-y-1"
};
const _hoisted_21 = {
  class: "min-w-0 break-words font-medium text-slate-700"
};
const _hoisted_22 = {
  class: "mt-1 flex items-start gap-x-4 gap-y-1"
};
const _hoisted_23 = {
  class: "min-w-0 break-words text-slate-600"
};
const _hoisted_24 = {
  key: 0,
  class: "mt-1 flex items-center gap-1 text-slate-500"
};
const _hoisted_25 = {
  class: "font-medium text-slate-700"
};
const _hoisted_26 = {
  class: "grid gap-2.5 md:grid-cols-[minmax(0,12rem)_minmax(0,1fr)]"
};
const _hoisted_27 = {
  class: "group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white transition-all duration-200 focus-within:border-emerald-300 focus-within:ring-2 focus-within:ring-emerald-100 hover:border-slate-300"
};
const _hoisted_28 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-1.5"
};
const _hoisted_29 = ["disabled"];
const _hoisted_30 = ["value"];
const _hoisted_31 = {
  class: "relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white"
};
const _hoisted_32 = {
  class: "flex items-center gap-1.5 border-b border-slate-100 px-3 py-1.5"
};
const _hoisted_33 = {
  class: "min-h-[4.25rem] px-3 py-2"
};
const _hoisted_34 = {
  key: 0,
  class: "mt-1 text-xs text-slate-400"
};
import { computed, reactive, watch } from 'vue';
import { CalendarDaysIcon, ChatBubbleLeftRightIcon, CheckCircleIcon, DocumentTextIcon, FlagIcon, SignalIcon, SparklesIcon, TrashIcon } from '@heroicons/vue/24/outline';
import { workReportTodoStatusLabel } from '../workReportUtils';
export default {
  __name: 'ReportWorkItemEditor',
  props: {
    item: {
      type: Object,
      required: true
    },
    phase: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    annotationCount: {
      type: Number,
      default: 0
    }
  },
  emits: ['update:item', 'remove', 'open-annotations'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const draft = reactive({});
    const resultOptions = [{
      value: 'IN_PROGRESS',
      label: '进行中'
    }, {
      value: 'COMPLETED',
      label: '已完成'
    }];
    const isTodoBacked = computed(() => Boolean(props.item.todoId));
    const showAnnotationButton = computed(() => Boolean(props.item.id && props.item.todoId));
    const currentTodoStatusLabel = computed(() => workReportTodoStatusLabel(props.item.currentTodoSnapshot?.status ?? props.item.todoSnapshot?.status));
    const expectedFinishAt = computed(() => props.item.expectedFinishAt ?? props.item.currentTodoSnapshot?.dueDate ?? props.item.todoSnapshot?.dueDate);
    const expectedFinishLabel = computed(() => formatDateTime(expectedFinishAt.value));
    const latestAnnotationContent = computed(() => normalizeText(props.item.todoLatestAnnotationContent ?? props.item.latestTodoAnnotationContent ?? props.item.currentTodoSnapshot?.todoLatestAnnotationContent ?? props.item.todoSnapshot?.todoLatestAnnotationContent));
    const latestAnnotationCreatorName = computed(() => normalizeText(props.item.todoLatestAnnotationCreatorName ?? props.item.latestTodoAnnotationCreatorName ?? props.item.currentTodoSnapshot?.todoLatestAnnotationCreatorName ?? props.item.todoSnapshot?.todoLatestAnnotationCreatorName));
    const latestAnnotationTime = computed(() => props.item.todoLatestAnnotationTime ?? props.item.latestTodoAnnotationTime ?? props.item.currentTodoSnapshot?.todoLatestAnnotationTime ?? props.item.todoSnapshot?.todoLatestAnnotationTime);
    const latestAnnotationMeta = computed(() => [latestAnnotationCreatorName.value, formatDateTime(latestAnnotationTime.value)].filter(Boolean).join(' · '));
    watch(() => props.item, value => {
      Object.keys(draft).forEach(key => delete draft[key]);
      Object.assign(draft, value || {});
      if (props.phase !== 'plan' && !isAllowedWorkItemResult(draft.result)) {
        draft.result = defaultWorkItemResult();
      }
    }, {
      immediate: true,
      deep: true
    });
    function emitItem() {
      emit('update:item', {
        ...draft
      });
    }
    function defaultWorkItemResult() {
      return 'IN_PROGRESS';
    }
    function isAllowedWorkItemResult(result) {
      return resultOptions.some(option => option.value === result);
    }
    function normalizeText(value) {
      return String(value || '').trim();
    }
    function formatDateTime(value) {
      const text = String(value || '').trim();
      if (!text) return '';
      const normalized = text.replace('T', ' ');
      const dateTime = normalized.match(/^(\d{4}-\d{2}-\d{2})\s+(\d{2}:\d{2})/);
      if (dateTime) return `${dateTime[1]} ${dateTime[2]}`;
      const dateOnly = normalized.match(/^(\d{4}-\d{2}-\d{2})/);
      return dateOnly ? dateOnly[1] : normalized;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("article", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", {
        class: "block truncate text-sm font-medium text-slate-800",
        title: __props.item.title || __props.item.todoSnapshot?.title || ''
      }, _toDisplayString(__props.item.title || __props.item.todoSnapshot?.title || '--'), 9, _hoisted_4), expectedFinishLabel.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(CalendarDaysIcon), {
        class: "h-3.5 w-3.5 shrink-0"
      }), _createElementVNode("span", null, "预计完结：" + _toDisplayString(expectedFinishLabel.value), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_6, [showAnnotationButton.value ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "relative rounded-lg p-1.5 text-slate-400 transition-colors duration-150 hover:bg-blue-50 hover:text-blue-600",
        title: "待办批注",
        "aria-label": "待办批注",
        onClick: _cache[0] || (_cache[0] = $event => emit('open-annotations'))
      }, [_createVNode(_unref(ChatBubbleLeftRightIcon), {
        class: "h-4 w-4"
      }), __props.annotationCount > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.annotationCount > 99 ? '99+' : __props.annotationCount), 1)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !__props.readonly ? (_openBlock(), _createElementBlock("button", {
        key: 1,
        type: "button",
        class: "rounded-lg p-1.5 text-slate-400 transition-colors duration-150 hover:bg-rose-50 hover:text-rose-500",
        title: "删除工作项",
        "aria-label": "删除工作项",
        onClick: _cache[1] || (_cache[1] = $event => emit('remove'))
      }, [_createVNode(_unref(TrashIcon), {
        class: "h-4 w-4"
      })])) : _createCommentVNode("", true)])]), __props.phase === 'plan' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("label", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_unref(FlagIcon), {
        class: "h-3.5 w-3.5 text-blue-500"
      }), _cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "text-xs font-semibold text-slate-600"
      }, "今日目标", -1))]), _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => draft.todayGoal = $event),
        class: "flex-1 resize-none border-0 bg-transparent px-3 py-1.5 text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none",
        rows: "2",
        readonly: __props.readonly,
        placeholder: "可按待办内容补充今日目标",
        onInput: emitItem
      }, null, 40, _hoisted_12), [[_vModelText, draft.todayGoal]]), __props.errors.todayGoal ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(__props.errors.todayGoal), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_unref(DocumentTextIcon), {
        class: "h-3.5 w-3.5 text-violet-500"
      }), _cache[5] || (_cache[5] = _createElementVNode("span", {
        class: "text-xs font-semibold text-slate-600"
      }, "最新批注", -1))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("p", {
        class: _normalizeClass(["whitespace-pre-wrap break-words text-sm leading-5", latestAnnotationContent.value ? 'text-slate-700' : 'text-slate-400'])
      }, _toDisplayString(latestAnnotationContent.value || '暂无批注'), 3), latestAnnotationMeta.value ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(latestAnnotationMeta.value), 1)) : _createCommentVNode("", true)])])])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createVNode(_unref(FlagIcon), {
        class: "mt-0.5 h-3 w-3 shrink-0 text-slate-400"
      }), _createElementVNode("span", _hoisted_21, _toDisplayString(__props.item.todayGoal || '--'), 1)]), _createElementVNode("div", _hoisted_22, [_createVNode(_unref(SparklesIcon), {
        class: "mt-0.5 h-3 w-3 shrink-0 text-slate-400"
      }), _createElementVNode("span", _hoisted_23, _toDisplayString(__props.item.expectedOutcome || '未填写预期成果'), 1)]), isTodoBacked.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_unref(SignalIcon), {
        class: "h-3 w-3 shrink-0"
      }), _createElementVNode("span", _hoisted_25, _toDisplayString(currentTodoStatusLabel.value), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_26, [_createElementVNode("label", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_unref(CheckCircleIcon), {
        class: "h-3.5 w-3.5 text-emerald-500"
      }), _cache[6] || (_cache[6] = _createElementVNode("span", {
        class: "text-xs font-semibold text-slate-600"
      }, "执行结果", -1))]), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => draft.result = $event),
        class: "w-full border-0 bg-transparent px-3 py-1.5 text-sm text-slate-700 focus:outline-none focus:ring-0",
        disabled: __props.readonly,
        onChange: emitItem
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(resultOptions, option => {
        return _createElementVNode("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_30);
      }), 64))], 40, _hoisted_29), [[_vModelSelect, draft.result]])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_unref(DocumentTextIcon), {
        class: "h-3.5 w-3.5 text-violet-500"
      }), _cache[7] || (_cache[7] = _createElementVNode("span", {
        class: "text-xs font-semibold text-slate-600"
      }, "最新批注", -1))]), _createElementVNode("div", _hoisted_33, [_createElementVNode("p", {
        class: _normalizeClass(["whitespace-pre-wrap break-words text-sm leading-5", latestAnnotationContent.value ? 'text-slate-700' : 'text-slate-400'])
      }, _toDisplayString(latestAnnotationContent.value || '暂无批注'), 3), latestAnnotationMeta.value ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(latestAnnotationMeta.value), 1)) : _createCommentVNode("", true)])])])]))]);
    };
  }
};